import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { HashRouter, Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
import DetailedDiagnosis from "./pages/DetailedDiagnosis";
import HappinessCheck from "./pages/HappinessCheck";
import AdminDashboard from "./pages/AdminDashboard";
import NotFound from "./pages/NotFound";
import ErrorBoundary from "./components/ErrorBoundary";

const queryClient = new QueryClient();

const App = () => {
  try {
    return (
      <ErrorBoundary>
        <QueryClientProvider client={queryClient}>
        <TooltipProvider>
          <Toaster />
          <Sonner />
          <HashRouter>
            <Routes>
          <Route path="/" element={<Index />} />
          <Route path="/detailed-diagnosis" element={<DetailedDiagnosis />} />
          <Route path="/happiness-check" element={<HappinessCheck />} />
          <Route path="/admin" element={<AdminDashboard />} />
          {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </HashRouter>
        </TooltipProvider>
      </QueryClientProvider>
      </ErrorBoundary>
    );
  } catch (error) {
    console.error('App rendering error:', error);
    return (
      <div style={{ padding: '20px', textAlign: 'center' }}>
        <h1>アプリケーションエラー</h1>
        <p>アプリケーションの読み込み中にエラーが発生しました。</p>
        <button onClick={() => window.location.reload()}>ページを再読み込み</button>
      </div>
    );
  }
};

export default App;
